import styledComponents, { useTheme, withTheme } from 'styled-components';
import { ThemePaletteType, ThemePaletteVariant } from './typings';
import paletteDark from './paletteDark';
import paletteLight from './paletteLight';
import defaultZIndex from './zIndex';
import defaultColors from './colors';
import spcColors from './spcColors';
import limeDark from './limeDark';
import limeLight from './limeLight';
import limexDark from './limexDark';
import limexLight from './limexLight';
import spcDark from './spcPaletteDark';
import spcLight from './spcPaletteLight';
import taDark from './taDark';
import taLight from './taLight';
export var styled = styledComponents;
export { useTheme, withTheme };
export var createTheme = function createTheme( // eslint-disable-next-line @typescript-eslint/default-param-last
type, colors, zIndex) {
  if (type === void 0) {
    type = ThemePaletteType.Light;
  }

  if (zIndex === void 0) {
    zIndex = defaultZIndex;
  }

  var theme = {
    type: type,
    zIndex: zIndex,
    fontFamilyLegacy: 'Roboto, sans-serif',
    fontFamily: 'Inter var, system-ui',
    palette: type === ThemePaletteType.Dark ? paletteDark : paletteLight,
    colors: colors
  };
  return theme;
};
export var getColors = function getColors(variant) {
  if (variant === void 0) {
    variant = ThemePaletteVariant.Orange;
  }

  switch (variant) {
    case ThemePaletteVariant.Blue:
      return spcColors;

    case ThemePaletteVariant.GreenLight:
      return spcColors;

    case ThemePaletteVariant.Green:
      return spcColors;

    case ThemePaletteVariant.Purple:
    case ThemePaletteVariant.Orange:
    default:
      return defaultColors;
  }
};
export var getPalette = function getPalette(type, variant) {
  if (type === void 0) {
    type = ThemePaletteType.Light;
  }

  if (variant === void 0) {
    variant = ThemePaletteVariant.Orange;
  }

  var isDark = type === ThemePaletteType.Dark;

  switch (variant) {
    case ThemePaletteVariant.Blue:
      return isDark ? spcDark : spcLight;

    case ThemePaletteVariant.GreenLight:
      return isDark ? limexDark : limexLight;

    case ThemePaletteVariant.Green:
      return isDark ? limeDark : limeLight;

    case ThemePaletteVariant.Purple:
      return isDark ? taDark : taLight;

    case ThemePaletteVariant.Orange:
    default:
      return isDark ? paletteDark : paletteLight;
  }
};
export var getTheme = function getTheme(type, variant) {
  if (type === void 0) {
    type = ThemePaletteType.Light;
  }

  if (variant === void 0) {
    variant = ThemePaletteVariant.Orange;
  }

  return {
    type: type,
    colors: getColors(variant),
    fontFamily: 'Inter var, system-ui',
    fontFamilyLegacy: 'Roboto, sans-serif',
    zIndex: defaultZIndex,
    palette: getPalette(type, variant)
  };
};